import { section } from "~/data";
import { pathname as SectionPathname } from "~/pages/section/index";

// This is to avoid missing query parameters from a base link for the app bar when redirecting with client route push, e.g. appBarVariant."
export const shouldRedirectBaseDynamicSectionLink = (
  pathName: string,
  query?: Record<string, string | undefined>,
) => {
  if (query?.appBarVariant) return false;
  return pathName === SectionPathname;
};

type GetIsSubSectionParameters = {
  entityId: string;
  parentSection: Nullish<string>;
};

export const getIsSubSection = ({ entityId, parentSection }: GetIsSubSectionParameters) => {
  const entityIdsOfSubSectionWithoutParentSection: string[] = [section.announcements.entityId];
  const parentSectionUuidsOfSection: string[] = [
    section.magazine.entityUuid,
    section.news.entityUuid,
    section.posties.read.entityUuid,
  ];

  return (
    entityIdsOfSubSectionWithoutParentSection.includes(entityId) ||
    (parentSection && !parentSectionUuidsOfSection.includes(parentSection))
  );
};

type GetTypeNameParameters = GetIsSubSectionParameters & {
  __typename: string;
  topicTypes: string[];
};

export const getTypeName = ({
  __typename,
  entityId,
  parentSection,
  topicTypes,
}: GetTypeNameParameters) => {
  if (topicTypes?.includes("news_agenda")) {
    return "NewsAgenda";
  }
  const isSubSection = getIsSubSection({
    entityId,
    parentSection,
  });
  if (__typename === "Section" && isSubSection) {
    return "SubSection";
  }
  return __typename;
};
